import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface SideDrawerDescriptionProps {
  description: string;
  learnMoreText?: string;
  learnMoreHref?: string;
  isMobileView?: boolean;
}

const SideDrawerDescription = ({
  description,
  learnMoreText = '',
  learnMoreHref = '',
  isMobileView = false,
}: SideDrawerDescriptionProps) => {
  const descWidth = isMobileView ? '90%' : '528px';
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="sideDrawer-header-description"
      width={descWidth}
    >
      {description}
      {learnMoreHref && learnMoreText && (
        <>
          <Link
            sx={{ ml: 0.5 }}
            href={learnMoreHref}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            data-testid="sideDrawer-header-learn-more"
          >
            {learnMoreText}
          </Link>
        </>
      )}
    </Typography>
  );
};

export default SideDrawerDescription;
